import { BACKEND_BASE, MEDIA_BASE } from "../api";

const MEDIA_PREFIXES = ["/media/", "/Media/"];

function stripTrailingSlash(v) {
    return (v || "").replace(/\/+$/, "");
}

function join(base, path) {
    const b = stripTrailingSlash(base);
    const p = (path || "").replace(/^\/+/, "");
    return b ? `${b}/${p}` : `/${p}`;
}

function toBasePrefix(urlLike) {
    if (!urlLike) return "";
    try {
        const u = new URL(urlLike);
        // важно: сохраняем pathname (например "/track-me-disk")
        return stripTrailingSlash(u.origin + u.pathname);
    } catch {
        return stripTrailingSlash(urlLike);
    }
}

export function makeToSafeMediaUrl(mediaBaseUrl, fallbackApiBaseUrl) {
    const mediaBase = toBasePrefix(mediaBaseUrl);
    const fallbackBase = toBasePrefix(fallbackApiBaseUrl);
    const base = mediaBase || fallbackBase; // теперь base может быть "https://s3.regru.cloud/track-me-disk"

    return function toSafeMediaUrl(input) {
        if (typeof input !== "string") return null;

        const s = input.trim();
        if (!s || s.includes("..")) return null;

        // Старые абсолютные /media/ URL тоже переносим на MEDIA_BASE.
        if (/^https?:\/\//i.test(s)) {
            try {
                const url = new URL(s);
                if (MEDIA_PREFIXES.some((p) => url.pathname.startsWith(p))) {
                    const normalized = `${url.pathname}${url.search}${url.hash}`;
                    return base ? join(base, normalized) : s;
                }
            } catch {
                return null;
            }
            return s;
        }

        // Если уже /media/... или /Media/...
        if (MEDIA_PREFIXES.some((p) => s.startsWith(p))) {
        return base ? join(base, s) : s;
        }

        // storage_path -> /media/<path>
        const p = s.replace(/^\/+/, "");
        if (/^(media|images|static)\//i.test(p)) {
            return base ? join(base, p) : `/${p}`;
        }
        const rel = `/media/${p}`;
        return base ? join(base, rel) : rel;
    };
}

export const toSafeMediaUrl = makeToSafeMediaUrl(MEDIA_BASE, BACKEND_BASE);
